import { Link } from 'react-router';

export default function AccessDeniedPage() {
  return (
    <div className="not-found-page">
      <h1>403 - Access Denied</h1>
      <p>You don't have permission to view this page. Contact your administrator.</p>
      <Link to="/dashboard">Go to Dashboard</Link>
    </div>
  );
}
